<template>

<section class="premium-section">

<h2 class="section-title">Legal Disclaimer</h2>

<p>
Mudra Token (MDR) is a utility token designed to reward creative content on the Mudra platform. The token is intended solely for use within the Mudra ecosystem.
</p>

<p>
Mudra Token is not a security, financial instrument, or investment contract. The project does not conduct initial coin offerings (ICO), token sales, or fundraising events.
</p>

<p>
Participation in the Mudra ecosystem is voluntary. Users may earn tokens through creative contributions such as writing stories, poems, or other content published on the platform.
</p>

<p>
The value of digital assets may fluctuate due to market conditions. The Mudra platform does not guarantee any financial returns, investment profits, or token price appreciation.
</p>

<p>
Users are responsible for complying with the laws, regulations, and tax obligations applicable in their respective jurisdictions.
</p>

<p>
The Mudra team aims to maintain transparency, fairness, and responsible development of the platform while supporting the global creator community.
</p>

</section>

</template>